import * as actionTypes from './FormActionTypes';

export const setAmount = (payload) => ({
  type: actionTypes.SET_AMOUNT,
  payload,
});

export const setReAmount = (payload) => ({
  type: actionTypes.SET_RE_AMOUNT,
  payload,
});

export const setCity = (payload) => ({
  type: actionTypes.SET_CITY,
  payload,
});

export const setNotes = (payload) => ({
  type: actionTypes.SET_NOTES,
  payload,
});

export const setStreet = (payload) => ({
  type: actionTypes.SET_STREET,
  payload,
});

export const setStreet2 = (payload) => ({
  type: actionTypes.SET_STREET_2,
  payload,
});

export const setZip = (payload) => ({
  type: actionTypes.SET_ZIP,
  payload,
});

export const setStateLocale = (payload) => ({
  type: actionTypes.SET_STATELOCALE,
  payload,
});

export const setOffice = (payload) => ({
  type: actionTypes.SET_OFFICE,
  payload,
});
